import * as React from 'react';
// @ts-ignore
import { Transition } from 'react-spring';
import { StyledSystemProps } from '../../../theme/StyledSystemProps';
import { CustomModalInner, ModalWrap } from './Elements';

const MODAL_ANIM_CONFIG = {
  duration: 250,
  tension: 100,
  friction: 10,
};

type ModalProps = StyledSystemProps & {
  onClose: () => void;
  children: React.ReactNode;
  open: boolean;
};

const CustomModal: React.FC<ModalProps> = ({ children, open }) => (
  <Transition
    items={open}
    native={true}
    config={MODAL_ANIM_CONFIG}
    from={{
      opacity: 0,
      transform: 'translateY(40px)',
    }}
    enter={{
      opacity: 1,
      transform: 'translateY(0)',
    }}
    leave={{
      opacity: 0,
      transform: 'translateY(40px)',
      pointerEvents: 'none',
    }}
  >
    {(modalOpen: any) =>
      modalOpen &&
      ((props: any) => (
        <ModalWrap style={{ opacity: props.opacity }}>
          <CustomModalInner>{children}</CustomModalInner>
        </ModalWrap>
      ))
    }
  </Transition>
);

export default CustomModal;
